import React, { useEffect, useState } from "react";
import { useSlate } from "slate-react";
import Button from "../common/Button";
import Icon from "../common/Icon";
import {
  toggleBlock,
  toggleMark,
  isMarkActive,
  addMarkData,
  isBlockActive,
  activeMark,
} from "../utils/SlateUtilityFunctions.js";
import defaultToolbarGroups from "./toolbarGroups.js";
const Toolbar = (props) => {
  const editor = useSlate();
  const [toolbarGroups, setToolbarGroups] = useState(defaultToolbarGroups);

  useEffect(() => {
    // Filter out the groups which are not allowed to be inserted when a table is in focus.
    let filteredGroups = [...defaultToolbarGroups];
    setToolbarGroups(filteredGroups);
  }, []);

  const BlockButton = ({ format, toolTipText }) => {
    return (
      <Button
        active={isBlockActive(editor, format)}
        format={format}
        toolTipText={toolTipText}
        onMouseDown={(e) => {
          e.preventDefault();
          toggleBlock(editor, format);
        }}
      >
        <Icon icon={format} />
      </Button>
    );
  };
  const MarkButton = ({ format, toolTipText }) => {
    return (
      <Button
        active={isMarkActive(editor, format)}
        format={format}
        toolTipText={toolTipText}
        onMouseDown={(e) => {
          e.preventDefault();
          toggleMark(editor, format);
        }}
      >
        <Icon icon={format} />
      </Button>
    );
  };
  const Dropdown = ({ format, options, ...rest }) => {
    return (
      <>
        <select
          value={activeMark(editor, format)}
          onChange={(e) => changeMarkData(e, format)}
          className="instruction_textEditor_select"
          aria-label={format}
        >
          {options.map((item, index) => (
            <option key={index} value={item.value}>
              {item.text}
            </option>
          ))}
        </select>
      </>
    );
  };
  const changeMarkData = (event, format) => {
    event.preventDefault();
    const value = event.target.value;
    addMarkData(editor, { format, value });
  };

  return (
    <div
      className="instruction_textEditor_toolbar"
      role="toolbar"
      aria-labelledby={props?.id}
    >
      {toolbarGroups.map((group, index) => (
        <span key={index} className="instruction_textEditor_toolbar-grp">
          {group.map((element) => {
            switch (element.type) {
              case "block":
                return <BlockButton key={element.id} {...element} />;
              case "mark":
                return <MarkButton key={element.id} {...element} />;
              case "dropdown":
                return <Dropdown key={element.id} {...element} />;

              default:
                return null;
            }
          })}
        </span>
      ))}
    </div>
  );
};

export default Toolbar;
